/**
 * Blog: el nav de secciones (.b-items-menu) arranca pegado al top del segundo
 * bloque y se fija bajo el header en cuanto toca el top al hacer scroll.
 * En mobile (< 992px) va siempre fijo arriba, el botón abre la lista y cada
 * entrada lleva a su sección y cierra la lista.
 * No usa el evento load: si algún recurso externo tarda, el pin no llegaría.
 */

const initBlogItemsMenu = () => {
	const menu = document.querySelector(':is(.b-blog-hero, .b-blog-category) ~ .b-items-menu');
	if (!menu) {
		return;
	}
	const firstSection = menu.previousElementSibling;
	const isMobile = () => document.documentElement.clientWidth < 992;
	const pin = () => {
		const headerOffset = isMobile() ? 78 : 83;
		menu.classList.toggle('is-pinned', isMobile() || firstSection.getBoundingClientRect().bottom <= headerOffset);
	};
	pin();

	// Abrir/cerrar el menú bloquea el scroll de la página mientras está abierto
	const setOpen = (open) => {
		menu.classList.toggle('open', open);
		document.documentElement.classList.toggle('blog-menu-open', open);
	};

	// section-wipe.js solo engancha el toggle si hay .wipe-section (no en el blog)
	const toggleBtn = menu.querySelector('.b-items-menu__toggle-btn');
	if (toggleBtn) {
		toggleBtn.addEventListener('click', () => setOpen(!menu.classList.contains('open')));
	}
	menu.querySelectorAll('.b-items-menu__list__item > a').forEach((link) => {
		link.addEventListener('click', () => {
			if (isMobile()) {
				setOpen(false);
			}
		});
	});
	document.addEventListener('scroll', pin, { passive: true, capture: true });
	window.addEventListener('resize', () => {
		pin();
		if (!isMobile()) {
			setOpen(false);
		}
	});
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initBlogItemsMenu);
} else {
	initBlogItemsMenu();
}
